const resolveAsset = (asset) => (asset && asset.default ? asset.default : asset);

export class ImagePaths {
    static appLogo = resolveAsset(require("../assets/png/HRZyra-Logo.png"));
    static loginLogo = resolveAsset(require("../assets/png/HRZyra-Logo.png"));
    static home = resolveAsset(require("../assets/svg/home.svg"));
    static dashboard = resolveAsset(require("../assets/svg/Dashboard.svg"));
    static admin = resolveAsset(require("../assets/svg/admin.svg"));
    static master = resolveAsset(require("../assets/svg/master.svg"));
    static configuration = resolveAsset(require("../assets/svg/configuration.svg"));
    static employee = resolveAsset(require("../assets/svg/Employee.svg"));
    static payroll = resolveAsset(require("../assets/svg/payroll.svg"));
    static attendance = resolveAsset(require("../assets/svg/attendance.svg"));
    static assetManagement = resolveAsset(require("../assets/svg/Assetmanagement.svg"));
    static reports = resolveAsset(require("../assets/svg/reports.svg"));
    static search = resolveAsset(require("../assets/svg/SearchLine.svg"));
    static filter = resolveAsset(require("../assets/svg/filter.svg"));
    static alignColumn = resolveAsset(require("../assets/svg/alignColumn.svg"));
    static export = resolveAsset(require("../assets/svg/export.svg"));
    static print = resolveAsset(require("../assets/svg/print.svg"));
    static draft = resolveAsset(require("../assets/svg/draft.svg"));
    static edit = resolveAsset(require("../assets/svg/edit.svg"));
    static editOff = resolveAsset(require("../assets/svg/editOff.svg"));
    static delete = resolveAsset(require("../assets/svg/delete.svg"));
    static logoutIcon = resolveAsset(require("../assets/svg/menu_line.svg"));
    static backArrow = resolveAsset(require("../assets/svg/BackArrow.svg"));
    static dragIcon = resolveAsset(require("../assets/svg/dragIcon.svg"));
    static defaultProfile = resolveAsset(require("../assets/svg/Male.svg"));
    static imageUpload = resolveAsset(require("../assets/svg/imageUpload.svg"));
    static documentPreview = resolveAsset(require("../assets/svg/document.svg"));
    static documentUpload = resolveAsset(require("../assets/svg/documentUpload.svg"));
    static companyProfile = resolveAsset(require("../assets/svg/Comapanyprofile.svg"));
    static pdfOn = resolveAsset(require("../assets/svg/pdfOn.svg"));
    static selectArrow = resolveAsset(require("../assets/svg/arrow_drop_down.svg"));
    static circleRight = resolveAsset(require("../assets/svg/circleRight.svg"));
    static circleWrong = resolveAsset(require("../assets/svg/circleWrong.svg"));
    static view = resolveAsset(require("../assets/svg/view.svg"));
    static bellIcon = resolveAsset(require("../assets/svg/NotificationBell.svg"));
    static playIcon = resolveAsset(require("../assets/svg/playIcon.svg"));
    static pauseIcon = resolveAsset(require("../assets/svg/pauseIcon.svg"));
    static notifyApprove = resolveAsset(require("../assets/svg/notifyApprove.svg"));
    static notifyReject = resolveAsset(require("../assets/svg/notifyReject.svg"));
    static birthDayIcon = resolveAsset(require("../assets/svg/birthdayIcon.svg"));
    static anniversaryIcon = resolveAsset(require("../assets/svg/anniversaryIcon.svg"));
    static modalEdit = resolveAsset(require("../assets/svg/modalEdit.svg"));
    static downloadPdf = resolveAsset(require("../assets/svg/downloadPdf.svg"));
    static moreIcon = resolveAsset(require("../assets/svg/threedots.svg"));
    static noDataFound = resolveAsset(require("../assets/svg/noDataFound.svg"));
    static clockReload = resolveAsset(require("../assets/svg/clockreload.svg"));
    static exportIcon = resolveAsset(require("../assets/svg/exportIcon.svg"));
    static previous = resolveAsset(require("../assets/svg/previous.svg"));
    static next = resolveAsset(require("../assets/svg/next.svg"));
    static filterFunnel = resolveAsset(require("../assets/svg/FilterFunnel.svg"));
    static mail = resolveAsset(require("../assets/svg/Mail.svg"));
    static call = resolveAsset(require("../assets/svg/Call.svg"));
    static location = resolveAsset(require("../assets/svg/Location.svg"));
    static addOff = resolveAsset(require("../assets/svg/Addoff.svg"));
    static teamLead = resolveAsset(require("../assets/svg/teamlead.svg"));
    static rosterIcon = resolveAsset(require("../assets/svg/rosterIcon.svg"));
    static reasonIcon = resolveAsset(require("../assets/svg/reasonIcon.svg"));
    static ApproveIcon = resolveAsset(require("../assets/svg/approval.svg"));
    static attachment_line = resolveAsset(require("../assets/svg/attachment_line.svg"));
    static downloadArrow = resolveAsset(require("../assets/svg/download.svg"));
    static documentUploadOutline = resolveAsset(require("../assets/svg/documentUploadOutline.svg"));
    static documentPdfOff = resolveAsset(require("../assets/svg/downloadPdfOff.svg"));
    static documentPdfOn = resolveAsset(require("../assets/svg/downloadPdfOn.svg"));
    static documentUploadOff = resolveAsset(require("../assets/svg/documentUploadOff.svg"));
    static downArrow = resolveAsset(require("../assets/svg/downArrow.svg"));
    static Upload = resolveAsset(require("../assets/svg/Upload.svg"));
    static myplan = resolveAsset(require("../assets/svg/plan.svg"));
    static tick_disabled = resolveAsset(require("../assets/svg/Frame 74.svg"));
    static tick_selected = resolveAsset(require("../assets/svg/Frame 75.svg"));
    static addicon = resolveAsset(require("../assets/svg/plus.svg"));
    static contact = resolveAsset(require("../assets/svg/Contact.svg"));
}
